import { Box, useTheme } from '@mui/material';
import { Users } from 'lucide-react';
import React from 'react';

interface NewCountBadgeProps {
    count: number;
    title?: string;
    size?: 'small' | 'medium';
}

export default function New_CountBadge({ count, title, size = 'medium' }: NewCountBadgeProps) {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    // Intensität basierend auf Anzahl
    const getIntensity = () => {
        if (count === 0) return 0.3;
        if (count <= 5) return 0.5;
        if (count <= 15) return 0.7;
        return 1.0;
    };

    const intensity = getIntensity();
    const primaryColor = theme.palette.primary.main;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 0.5,
                px: 1,
                py: 0.5,
                borderRadius: 1,
                bgcolor: primaryColor,
                border: `1px solid ${primaryColor}`,
                minWidth: size === 'small' ? 45 : 55,
                height: size === 'small' ? 20 : 24,
            }}
            title={title}
        >
            <Box
                sx={{
                    color: theme.palette.getContrastText(primaryColor),
                    display: 'flex',
                    opacity: intensity,
                }}
            >
                <Users size={size === 'small' ? 12 : 14} />
            </Box>
            <Box
                sx={{
                    fontSize: size === 'small' ? '0.7rem' : '0.75rem',
                    fontWeight: 600,
                    color: theme.palette.getContrastText(primaryColor),
                    lineHeight: 1,
                }}
            >
                {count}
            </Box>
        </Box>
    );
}
